import Chip from "@mui/material/Chip";
import Tooltip from "@mui/material/Tooltip";

export type RelayItsSource = "directory" | "sabil_only" | "nowhere";

const SOURCE_CONFIG: Record<
  RelayItsSource,
  {
    label: string;
    color: "success" | "warning" | "error";
    tooltip: string;
  }
> = {
  directory: {
    label: "In directory",
    color: "success",
    tooltip: "ITS found in the Jamaat directory",
  },
  sabil_only: {
    label: "Sabil only",
    color: "warning",
    tooltip: "ITS not in directory, but found on a sabil record",
  },
  nowhere: {
    label: "Not found",
    color: "error",
    tooltip: "ITS not found in directory or sabil records",
  },
};

export function getRelayItsSourceLabel(source: RelayItsSource): string {
  return SOURCE_CONFIG[source].label;
}

type RelayItsSourceChipProps = {
  source?: RelayItsSource | null;
  size?: "small" | "medium";
  variant?: "filled" | "outlined";
};

export default function RelayItsSourceChip({
  source,
  size = "small",
  variant = "outlined",
}: RelayItsSourceChipProps) {
  if (!source) {
    return null;
  }

  const config = SOURCE_CONFIG[source];

  return (
    <Tooltip title={config.tooltip}>
      <Chip size={size} color={config.color} variant={variant} label={config.label} />
    </Tooltip>
  );
}
